import * as z from "zod/v4";

export const verifyOneTimePasscode = {
  name: "verifyOneTimePasscode" as const,
  input: z.object({
    fourDigitCodeId: z.string(),
    passcode: z.string(),
    customerEmail: z.string(),
    teamId: z.string(),
    currentLocation: z.string().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    customerAuthToken: z.string().optional(),
    multipassUrl: z.string().optional(),
  }),
};
